var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.p_diagnosisEntryStatus)?_c('el-button',{staticClass:"statusBtn",attrs:{"type":"success","size":_vm.size},on:{"click":_vm.switchStatus}},[_vm._v(_vm._s(_vm.completedText)+" ")]):_c('el-button',{staticClass:"statusBtn",attrs:{"type":"info","size":_vm.size},on:{"click":_vm.switchStatus}},[_vm._v(_vm._s(_vm.incompleteText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }